import * as angular from 'angular';
import template from './plcConfig.tpl.html';

export default angular.module('aps.controller.plcConfig', [])
  .directive('apsPlcConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/plcConfig.directive.ts